export default {
    /**
     *
     * @param commit
     * @param data {Session}
     */
    setSession({commit}, data) {
        commit('setSession', data);
    },
    setView({commit}, view) {
        commit('setView', view);
    },
    /**
     *
     * @param state
     * @param message {Message}
     */
    async showNotification({state, dispatch, getters, rootState}, message) {
        if (rootState.chat.room.instance && rootState.chat.room.instance.id == message.roomID && rootState.showChat) { //room is open now
            return;
        }
        if (!state.profiles.list[message.userID]) {
            try {
                await dispatch('chat/profiles/fetchProfile', message.userID, {root: true});
            }
            catch (e) {
                dispatch('reportException', e, {root: true});
            }
        }
        let user = '';
        if (state.profiles.list[message.userID]) {
            user = state.profiles.list[message.userID].fullName();
        }

        if (message.userID != state.session.userId) {
            if (message.isRegular()) {
                state.notificationManager.newMessage(user, message);
            }
            else if (message.isOut()) {
                const room = getters['chat/rooms/roomById'](message.roomID);
                state.notificationManager.userOut(room, user, message);
            }
            else {
                const room = state.rooms.list.find(item => item.id == message.roomID);
                state.notificationManager.userIn(room, user, message);
            }
        }
    },
    increaseReconnectTimeout({ state, commit }) {
        if (state.reconnectTimeout >= 300000) {
            return;
        }
        let value = 0;
        switch (state.reconnectTimeout) {
            case 0:
                value = 5000;
                break;
            case 5000:
                value = 15000;
                break;
            case 15000:
                value = 30000;
                break;
            default:
                value = state.reconnectTimeout + 30000;
        }
        commit('setReconnectTimeout', value);
    },
    resetReconnectTimeout({ commit }) {
        commit('setReconnectTimeout', 0);
    },
    setTokenFetching({commit}, value) {
        commit('setTokenFetching', value);
    },
    setClient({commit}, client) {
        commit('setClient', client);
    },
    relogin({state, rootState}) {

    },
    async messageToGroupChat({ rootState, dispatch }, { title, message, membersUserIds }) {

        let group = rootState.chat.rooms.list.find(item => item.title === title && item.type == 'privateGroup');

        if (!group) {

            try {
                group = await dispatch('chat/groups/createPrivateGroup', { title, membersUserIds }, { root: true });
            }
            catch (e) {
                dispatch('reportException', e, { root: true });
            }
        }

        if (group) {
            rootState.chat.socket.sendMessages({
                roomID: group.id,
                message: message,
                type: 1
            });
            return true;
        }

        return false;
    }
}
